import { TRole } from '../types/security.types';

//#region Common

export interface ICredentials {
  maxusername: string;
  maxpassword: string;
  IPVerificationCode?: number;
}

export interface IUser {
  userId?: number;
  userName?: string;
  email?: string;
  fullName?: string;
  roles?: Array<TRole>;

  //TODO: Move those methods to User Service
  impersonate?: TRole;
  readonly isInRole?: (role: TRole) => boolean;
  readonly isAdmin?: () => boolean;
}

//#endregion

//#region O2

/* export interface IO2User extends IUser {
  preferences?: unknown;
} */

//#endregion

//#region Cedric

// TODO: When new Authentication System is in place, this needs to be merged with IUser
export interface ICedricUser extends IUser {
  userId: number;
  userName: string;
  fullName: string;
  securityGroups?: Array<ISecurityGroup>;
}

export interface ISecurityGroup {
  securityGroupId: number;
  name: string;
  isDeleted: boolean;
  isDefault?: boolean;
  createdBy: string;
  createdOn: string;
  modifiedBy: string;
  modifiedOn: string;
  users: IUserInSecurityGroup[];
}

export interface IUserInSecurityGroup {
  securityGroupId: number;
  userId: number | string;
  fullName: string;
  name: string;
}

export interface LoginRequest {
  userName: string;
  password: string;
  rememberMe: boolean;
  passthroughParams?: Record<string, string | string[]>;
}

export interface LoginResult {
  access_token?: string;
  token_type?: string;
  expires_in?: number;
  id_token?: string;
  scope?: string;
  error?: string;
  error_description?: string;
  redirectUrl?: string;
  message?: string;
  success?: boolean;
  requiresLocationVerification?: boolean;
  requiresSecondFactor?: boolean;
  methods?: string[];
  defaultMethod?: string;
  maskedTarget?: string | null;
  requiresSecondFactorEnrolment?: boolean;
  method?: string;
}

export interface ApiMessageResult {
  message?: string;
  error?: string;
  error_description?: string;
}

export interface ResetPasswordResult extends ApiMessageResult {
  /**
   * Absolute URL of the application the reset was requested from, so the user can be sent
   * back to it. Absent when the reset started outside an authorization request.
   */
  returnUrl?: string;
}

export interface UserInfoResult {
  sub?: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  preferred_username?: string;
  email?: string;
  [key: string]: unknown;
}

//#endregion
